import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import {
	IntegrationLinkCardProps,
	IntegrationOption,
	integrationsConfig,
} from "../../../../components/Home/Overview/Integrations/OverviewIntegrations";
import BriaBadge from "../../../../components/common/BriaBadge/BriaBadge";
import BriaTooltip from "../../../../components/common/BriaTooltip/BriaTooltip";
import styles from "./ProductsWidgetIntegrations.module.scss";

const groupedIntegrations: { title: string; options: IntegrationOption[] }[] = [
	{
		title: "payWith",
		options: ["AWS", "AZURE"],
	},
	{
		title: "findUs",
		options: ["FAL", "HUGGING_FACE", "REPLICATE"],
	},
	{
		title: "useIn",
		options: ["COMFY_UI", "INVOKE", "CLAUDE"],
	},
];

const ProductsWidgetIntegrations = () => {
	const { t } = useTranslation("dashboard", { keyPrefix: "products.integrate" });

	return (
		<Box>
			<Box className={styles.header}>
				<Typography className={styles.title}>{t("title")}</Typography>
				<Typography className={styles.description}>{t("description")}</Typography>
			</Box>

			<Box className={styles.integrations}>
				{groupedIntegrations.map((group) => (
					<Box key={group.title} className={styles.group}>
						<Typography className={styles.groupTitle}>{t(`groups.${group.title}`)}</Typography>
						<Box className={styles.groupOptions}>
							{group.options.map((integration) => (
								<BriaTooltip title={t(`integrations.${integration}.label`)}>
									<IntegrationLinkCard key={integration} {...integrationsConfig[integration]} />
								</BriaTooltip>
							))}
						</Box>
					</Box>
				))}
			</Box>
		</Box>
	);
};

export default observer(ProductsWidgetIntegrations);

// Single integration card
const IntegrationLinkCard = ({ icon, label, link, badgeLabel, openInNewTab = true }: IntegrationLinkCardProps) => {
	const cardContent = (
		<>
			<img className={styles.icon} src={icon} alt={label} />
			{badgeLabel && <BriaBadge className={styles.badge} label={badgeLabel} />}
		</>
	);

	if (link) {
		return (
			<NavLink
				className={styles.clickableCard}
				to={link}
				target={openInNewTab ? "_blank" : undefined}
				rel={openInNewTab ? "noopener noreferrer" : undefined}
			>
				{cardContent}
			</NavLink>
		);
	}

	return <Box className={styles.card}>{cardContent}</Box>;
};
